// extracted by mini-css-extract-plugin
export default {"infoHeroBlock":"ReqAndMoneyInfo-module__infoHeroBlock__zueWU"};